import { type } from '@ngrx/signals'
import { eventGroup } from '@ngrx/signals/events'

import type { GetConversationResponse, UnlockConversationResponse } from '../../models/api.model'
import type { Conversation } from '../../models/conversation.model'
import type { ConversationProfile } from '../../models/conversation-profile.model'

export const conversationEvents = eventGroup({
  source: 'Conversation',
  events: {
    select: type<{ profileBrowseId: string | undefined; isSuggestedProfile?: boolean }>(),

    load: type<{ profileBrowseId: string; isSuggestedProfile?: boolean }>(),
    loadSuccess: type<{ response: GetConversationResponse }>(),
    loadFailure: type<{ profileBrowseId: string; error: any }>(),
    loadEnd: type<void>(),

    loadMoreMessages: type<{ conversation: Conversation; next_cursor: string }>(),
    loadMoreMessagesSuccess: type<{ response: GetConversationResponse }>(),
    loadMoreMessagesFailure: type<{ error: any }>(),
    loadMoreMessagesEnd: type<void>(),

    remove: type<{ conversation: Conversation }>(),
    removeSuccess: type<{ conversation: Conversation }>(),
    removeFailure: type<{ error: any }>(),
    removeEnd: type<void>(),

    unlock: type<{ conversation: Conversation }>(),
    unlockSuccess: type<{ response: UnlockConversationResponse }>(),
    unlockFailure: type<{
      error: any
      profile_id: number
    }>(),
    unlockEnd: type<void>(),

    updateProfile: type<{ profile: Partial<ConversationProfile> }>(),
  },
})
